import React from "react";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
interface Props {
  price: number;
  link: string;
  hasMapStyle: boolean;
}
const OutletOffer = ({
  price,
  link,
  hasMapStyle
}: Props) => {
  return <div data-testid="outlet-item" data-sentry-component="OutletOffer" data-sentry-source-file="OutletOffer.tsx">
      <div className="mb-2 py-1 px-2 rounded-sm bg-gray-100">
        <a className="block text-gray-800 font-semibold hover:text-red-700 text-xs" style={{
        textShadow: "none"
      }} href={link} title="WebstaurantStore Outlet" data-testid="outlet-item-link">
          {hasMapStyle ? "Also available in Scratch and Dent " : <>
              Available in Scratch &amp; Dent for
              <span data-testid="outlet-item-price" className="text-sm text-red-700 font-bold">
                {` ${formatAsCurrency.formatIfUndefined(price)} `}
              </span>
            </>}
          <i className="icon-breadcrumb" />
        </a>
      </div>
    </div>;
};
export default OutletOffer;